var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 8.99217L12.67 8.99217L7.79 13.8722C7.4 14.2622 7.4 14.9022 7.79 15.2922C8.18 15.6822 8.81 15.6822 9.2 15.2922L15.79 8.70217C16.18 8.31217 16.18 7.68217 15.79 7.29217L9.21 0.692173C8.82 0.302173 8.19 0.302173 7.8 0.692173C7.41 1.08217 7.41 1.71217 7.8 2.10217L12.67 6.99217L1.5 6.99217C0.95 6.99217 0.5 7.44217 0.5 7.99217C0.5 8.54217 0.95 8.99217 1.5 8.99217Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.ad5c63387a4d26aea59acd7e39caf7c4.svg";
export { ForwardRef as ReactComponent };